<template>

  <Header />

  <SearchCustomers />

  <div class="section container section--lg">
    <div class="content">
      <div class="heading">
        <router-link to="/orders">
          <h1>Recently Seeded</h1>
        </router-link>
      </div>
      <CustomerTable :columns="orderColumns"
                     :rows="orders"
                     :fields="orderFields"
                     :no-data="'No orders yet!'"
                     :displayTypes="false"
                     :requestCompleted="requestCompleted"
                     @row-click="viewOrderDetails"/>
    </div>
  </div>

  <div class="section container section--lg">
    <div class="content">
      <div class="heading">
        <router-link to="/profiles">
          <h1>Customer List</h1>
        </router-link>
      </div>
      <CustomerTable :columns="customerColumns"
                     :rows="customers"
                     :fields="customerFields"
                     :no-data="'No customers found!'"
                     :requestCompleted="requestCustomerCompleted"
                     :sortable="true"
                     :displayTypes="true"
                     @update-sort="updateCustomerSort"
                     @row-click="viewCustomerDetails"/>
    </div>
  </div>

</template>

<script>
import Header from '../components/Header.vue';
import SearchCustomers from '../components/SearchCustomers.vue';
import CustomerTable from '../components/CustomerTable.vue';

export default {
  name: 'Home',
  components: {
    Header, SearchCustomers, CustomerTable
  },
  methods: {
    viewOrderDetails(order) {
      this.$router.push(`/order/${order.order_number}`);
    },
    viewCustomerDetails(customer) {
      this.$router.push(`/customer/${customer.shopify_id}`);
    },
    getCustomers(params, nextPage){
      let q = `?sort_by=${params.sortBy}&sort_direction=${params.sortDirection}`;
      if (nextPage) {
        sessionStorage.setItem('page', JSON.stringify(nextPage));
        q += `&page=${nextPage}`;
      }
      this.axios.get('/v1/customers.json' + q)
        .then(response => {
          if (typeof response.data.records !== 'undefined') {
            if (nextPage) {
              this.tempCustomerOrder[nextPage] = response.data.records
              this.customers = this.tempCustomerOrder.flat();
            } else {
              this.tempCustomerOrder.length = 0;
              this.customers = response.data.records;
              this.tempCustomerOrder[0] = this.customers;
              this.customerNextPage = 1;
            }
          }
          this.customerPages = response.data.pages;
          this.requestCustomerCompleted = true;
        })
        .catch((error) => {
          console.log(error)
        });
    },
    scrollHandler(top = null) {
      if (top !== null) {
        const bottomOfWindow = window.scrollY;
        if (top > bottomOfWindow) {
          window.scrollTo({
            top: top,
          });

          setTimeout(() => this.scrollHandler(top), 300);
        }
      } else {
        const nearBottom = document.documentElement.scrollTop + window.innerHeight >= (document.documentElement.offsetHeight - 100);

        if (nearBottom) {
          ++this.customerNextPage;
          if (this.customerNextPage > this.customerPages) {
            return;
          }
          this.getCustomers(this.customerTableParams, this.customerNextPage);
        }
      }
    },
    updateCustomerSort(sortBy, sortDirection){
      this.customerTableParams = { sortBy: sortBy, sortDirection: sortDirection };
      this.getCustomers(this.customerTableParams);
    },
    getStatusColor({ status }) {
      switch (status.toLowerCase()) {
        case 'shipped':
          return 'col__status--yellow';
        case 'delivered':
          return 'col__status--green';
        case 'draft':
          return 'col__status--red';
        case 'expired':
          return 'col__status--gray';
        case 'canceled':
          return 'col__status--gray';
        default:
          return '';
      }
    }
  },
  data() {
    return {
      orders: [],
      page: 1,
      requestCompleted: false,
      orderColumns: [
        { name: 'status', label: 'Status' },
        { name: 'tracking', label: 'Tracking' }],
      orderFields: [
        { name: 'status', format: (data) => data.status.replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) || 'N/A', classNames: (data) => `col__status ${this.getStatusColor(data)}` },
        {
          name: 'tracking',
          format: (data) => data.tracking_details.length && data.tracking_details[0].url ? '<a href=' + data.tracking_details[0].url + ' target="_blank">LINK</a>' : 'N/A'
        }
      ],
      requestCustomerCompleted: false,
      customers: [],
      customerColumns: [{ name: 'last_seeded', label: 'Last seeded date', classNames: 'col__last-seeded'}],
      customerFields: [{
        name: 'last_seeded', format: (data) => {
          return data.last_seeded ? this.helpers.formatDateShort(data.last_seeded) : '-'
        },
        classNames: () => { return 'col__last-seeded-date'; }
      }],
      customerTableParams:{
        sortBy: 'full_name',
        sortDirection: 'asc',
      },
      customerNextPage: 1,
      customerPages: null,
      tempCustomerOrder: []
    }
  },
  mounted() {
    document.body.classList.remove('menu-open');
    this.axios.get('/v1/orders.json?limit=6')
      .then(response => {
        if(typeof response.data.records !== 'undefined') {
          this.orders = response.data.records;
        }
        window.dispatchEvent(new CustomEvent('scroll-ready', {
          detail: {
            page: JSON.parse(sessionStorage.getItem('page'))
          }
        }))
        this.requestCompleted = true;
      })
     .catch((error) => { console.log(error) });
    this.getCustomers(this.customerTableParams);
    window.addEventListener('scroll', (event) => {
      if (event?.detail) {
        this.scrollHandler(event.detail.position.top)
      } else {
        this.scrollHandler()
      }
    })
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.scrollHandler);
  }
}
</script>
